export const toLocaleBrowserSettings = (value: number) => {
  return value.toLocaleString(globalThis.navigator.language);
};
